import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import zip from 'lodash/zip';
import sum from 'lodash/sum';
import Button from 'components/Button';
import Answer from './Answer';
import PollActions from './PollActions';
import styles from './PollResults.css?module';

const Actions = ({onHideResults}) => (
  <PollActions>
    <Button
      className={styles.button}
      onClick={onHideResults}
      type={Button.TYPES.ALT}
      quiet={true}
    >
      <FormattedMessage
        id="PollResults__Back"
        description="Label for button to go back to poll question"
        defaultMessage="Back"
      />
    </Button>
  </PollActions>
);

const PollResults = ({poll, canHideResults, onHideResults}) => {
  const answersWithVotes = zip(poll.answers, poll.totalVotes).sort(
    (a, b) => b[1] - a[1]
  );
  const totalVoteCount = sum(poll.totalVotes);
  const answers = answersWithVotes.map(([answer, votes], index) => (
    <Answer
      key={index}
      answer={answer}
      votes={votes}
      totalVoteCount={totalVoteCount}
    />
  ));

  return (
    <div>
      <div className={styles.answers}>{answers}</div>
      {canHideResults ? <Actions onHideResults={onHideResults} /> : null}
    </div>
  );
};

PollResults.propTypes = {
  poll: PropTypes.object.isRequired,
  onHideResults: PropTypes.func.isRequired,
};

export default PollResults;
